import { Link } from "react-router-dom";
import { Box, Card, Grid, Paper, Typography } from "@mui/material";
import { Navbar } from "../styled/nav-bar";

import { OutlinedButtonCard } from "../styled/outlined-button-card";

const cardItems = [
  {
    title: "Befunde und Fortschritt Ihrer Patienten",
    link: "patients",
    image: "/img-clinic/clinic-dashboard-1.png",
  },
  {
    title: "Termin für Patienten buchen",
    link: "https://www.adipositasgutachten.de/termin",
    image: "/img-clinic/clinic-dashboard-2.png",
  },
  {
    title: "adipositasgutachten.de soll Patienten anrufen",
    link: "https://www.adipositasgutachten.de/anrufen",
    image: "/img-clinic/clinic-dashboard-3.png",
  },
  {
    title: "Termin für fachliche Absprache",
    link: "https://www.adipositasgutachten.de/fachliche-absprache",
    image: "/img-clinic/clinic-dashboard-4.png",
  },
  {
    title: "Kostenlos neue Flyer bestellen",
    link: "https://www.adipositasgutachten.de/flyer",
    image: "/img-clinic/clinic-dashboard-5.png",
  },
  {
    title: "StuDoQ",
    link: "studoq",
    image: "/img-clinic/clinic-dashboard-6.png",
  },
];

export const ClinicDashboard = () => {
  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      spacing={4}
      pt={2}
      pr={2}
      pl={2}
      pb={5}
    >
      <Navbar />

      <Grid
        item
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "85%",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            padding: "15px",
            borderRadius: "20px",
          }}
        >
          <Grid container>
            <Grid item>
              <Typography padding={2}>
                Liebe Kolleginnen und Kollegen,
              </Typography>{" "}
              <Typography padding={2}>
                herzlich willkommen im exklusiven Login-Bereich für Ihre Klinik.
              </Typography>{" "}
              <Typography padding={2}>
                {" "}
                Wir freuen uns, Sie in unserem speziell für Kliniken
                entwickelten Bereich begrüßen zu dürfen. Unser Ziel ist es,
                Ihnen die Zusammenarbeit mit adipositasgutachten.de so einfach
                und effizient wie möglich zu gestalten.
              </Typography>
              <Typography padding={2}>
                {" "}
                Bei Fragen schreiben Sie uns gerne eine E-Mail an
                kliniken@adipositasgutachten.de
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "15px",
        }}
      >
        {cardItems.map((item, index) => (
          <Grid
            item
            key={index}
            xs={12}
            sm={4}
            padding="15px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Card
              sx={{
                backgroundColor: "grey.400",
                width: "280px",
                height: "260px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <img
                  src={item.image}
                  alt={item.title}
                  style={{ width: "100%", height: "150px" }}
                />
                <Typography fontWeight="700" align="center">
                  {item.title}
                </Typography>
              </Box>
              <Box
                width="100%"
                display="flex"
                justifyContent="center"
                alignItems="end"
                sx={{ mt: "auto", mb: "10px", padding: "5px" }}
              >
                {item.title === "StuDoQ" ? (
                  <Link to={item.link}>
                    <OutlinedButtonCard children={"weiter"} />
                  </Link>
                ) : (
                  <Link to={item.link}>
                    <OutlinedButtonCard children={"weiter"} />
                  </Link>
                )}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
